<template lang="pug">
.ban-data-container(@click="expand = !expand")
  .ban-data
    .ban-type
      span.material-symbols-outlined block
      span.ban-type-badge {{ typeLabel }}

    .ban-value {{ data.value || '—' }}
    .ban-name.capitalize(v-if="data.name") {{ cutValue(data.name) }}
    .ban-name(v-else) —
    .ban-order {{ data.order || '—' }}
    .ban-date {{ dateName(data.createdAt) }}

  transition(name="slide-fade")
    .ban-details(v-if="expand" @click.stop="")
      .ban-detail-row
        span.ban-detail-label Tipo
        span.ban-detail-value {{ typeLabel }}
      .ban-detail-row
        span.ban-detail-label Valor
        span.ban-detail-value {{ data.value || '—' }}
      .ban-detail-row
        span.ban-detail-label Nombre
        span.ban-detail-value.capitalize {{ data.name || '—' }}
      .ban-detail-row
        span.ban-detail-label Orden
        span.ban-detail-value {{ data.order || '—' }}
      .ban-detail-row
        span.ban-detail-label Baneado por
        span.ban-detail-value {{ data.bannedBy || '—' }}
      .ban-detail-row
        span.ban-detail-label Creado
        span.ban-detail-value {{ dateTime(data.createdAt) }}
</template>

<script>
import mFilters from '@/mixins/filters'

const TYPE_LABELS = {
  phone: 'Teléfono',
  email: 'Email',
  dni: 'Cédula'
}

export default {
  name: 'Ban',

  mixins: [mFilters],

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  computed: {
    typeLabel () {
      return TYPE_LABELS[this.data.type] || this.data.type || '—'
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    cutValue (value) {
      if (!value) return ''
      const maxLength = 18
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    }
  }
}
</script>

<style lang="stylus">
.ban-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em
  justify-content space-between

.ban-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em
  padding 0 1rem

.ban-type
  display flex
  align-items center
  gap 0.4em

.ban-type .material-symbols-outlined
  font-size 1.3em
  color #d9534f

.ban-type-badge
  font-weight 600

.ban-details
  flex-basis 100%
  padding 0 1rem 1rem
  display flex
  flex-direction column
  gap 0.75rem

.ban-detail-row
  display flex
  gap 1rem
  flex-wrap wrap

.ban-detail-row .ban-detail-label
  min-width 7rem
  font-weight 600
  color #666
  position static
  text-transform none

.ban-detail-row .ban-detail-value
  word-break break-all

@media (pointer: fine)
  .ban-data
    flex-basis 100%
    column-gap 0
    row-gap 1em

  .ban-type
    width 11em

  .ban-value
    width 16em

  .ban-name
    width 12em

  .ban-order
    width 9em

  .ban-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/ban/Ban.vue